/**
 * Same-origin URL for static files under GET /api/uploads/:filename.
 * Using the current page origin avoids www vs apex and env hostname mismatches
 * (common on mobile when the baked-in API host differs from the site URL).
 */
export function publicUploadUrl(filename) {
  if (!filename) return '';
  return `/api/uploads/${encodeURIComponent(filename)}`;
}
